// extracted by mini-css-extract-plugin
export default {"BannerContainer":"BannerContent_BannerContainer__VqtKz","ReadOnly":"BannerContent_ReadOnly__HcUtD","BannerContainer__Warning":"BannerContent_BannerContainer__Warning__4q6EP"};